module.exports = __webpack_public_path__ + "img/gb-wls.f8d71ca6.svg";